const footerData = {
    top: [
        {
            type: 'List',
            children: [
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Food',
                    children: [
                        {
                            text: 'Menu',
                            href: 'https://www.nandos.co.uk/food/menu',
                            type: 'Link'
                        },
                        {
                            text: 'What’s New',
                            href: 'https://www.nandos.co.uk/food/whats-new',
                            type: 'Link'
                        },
                        {
                            text: 'Recipes',
                            href: 'https://www.nandos.co.uk/food/recipes',
                            type: 'Link'
                        },
                        {
                            text: 'Shop',
                            href: 'https://www.nandos.co.uk/food/shop',
                            type: 'Link'
                        },
                        {
                            text: 'Our Food',
                            href: 'https://www.nandos.co.uk/food/our-food',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Restaurants',
                    children: [
                        {
                            text: 'Find a Nando’s',
                            href: 'https://www.nandos.co.uk/restaurants/search',
                            type: 'Link'
                        },
                        {
                            text: 'View All Restaurants',
                            href: 'https://www.nandos.co.uk/restaurants',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Nando’s Card',
                    children: [
                        {
                            text: 'Join now',
                            href: 'https://www.nandos.co.uk/card/auth/register',
                            type: 'Link'
                        },
                        {
                            text: 'How it works',
                            href: 'https://www.nandos.co.uk/card/about',
                            type: 'Link'
                        },
                        {
                            text: 'Lost Card',
                            href: 'https://www.nandos.co.uk/card/lost-your-card',
                            type: 'Link'
                        },
                        {
                            type: 'Divider'
                        },
                        {
                            text: 'Log In',
                            href: 'https://www.nandos.co.uk/card/auth/login',
                            type: 'Link',
                            className: 'login'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Explore',
                    children: [
                        {
                            text: 'Our Blog',
                            href: 'https://www.nandos.co.uk/explore/blog',
                            type: 'Link'
                        },
                        {
                            text: 'The Nando’s App',
                            href: 'https://www.nandos.co.uk/explore/app',
                            type: 'Link'
                        },
                        {
                            text: 'Being Sustainable',
                            href: 'https://www.nandos.co.uk/explore/being-sustainable',
                            type: 'Link'
                        },
                        {
                            text: 'Fighting Malaria',
                            href: 'https://www.nandos.co.uk/explore/fightingmalaria',
                            type: 'Link'
                        },
                        {
                            text: 'This is PERi-PERi',
                            href: 'https://www.nandos.co.uk/explore/this-is-peri-peri',
                            type: 'Link'
                        },
                        {
                            text: 'Art',
                            href: 'https://www.nandos.co.uk/explore/art',
                            type: 'Link'
                        },
                        {
                            text: 'Music',
                            href: 'https://www.nandos.co.uk/explore/music',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Help',
                    children: [
                        {
                            text: 'Search FAQs',
                            href: 'https://help.nandos.co.uk/hc/en-gb',
                            type: 'Link'
                        },
                        {
                            text: 'My Account',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003170978-My-Account',
                            type: 'Link'
                        },
                        {
                            text: 'Food',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003177877-Our-Food',
                            type: 'Link'
                        },
                        {
                            text: 'Online Ordering',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003166618-Online-Ordering',
                            type: 'Link'
                        },
                        {
                            text: 'Restaurants',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003177897-Our-Restaurants',
                            type: 'Link'
                        },
                        {
                            text: 'Nando’s Card & Discounts',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003170958-Nando-s-Cards-Gift-Cards-Discounts',
                            type: 'Link'
                        },
                        {
                            text: 'Fundraising Requests',
                            href: 'https://help.nandos.co.uk/hc/en-gb/articles/360016324818-I-Am-Organising-A-Fundraising-Event-Can-You-Help-#corporate',
                            type: 'Link'
                        },
                        {
                            text: 'Sustainability',
                            href: 'https://help.nandos.co.uk/hc/en-gb/categories/360003170918-Sustainability',
                            type: 'Link'
                        },
                        {
                            text: 'Contact Us',
                            href: 'https://help.nandos.co.uk/hc/en-gb/requests/new?ticket_form_id=360000261658',
                            type: 'Link'
                        }
                    ]
                },
                {
                    type: 'Link',
                    className: 'fLink',
                    text: 'Legal',
                    children: [
                        {
                            text: 'Terms & Conditions',
                            href: 'https://www.nandos.co.uk/nandos-terms-and-conditions',
                            type: 'Link'
                        },
                        {
                            text: 'Privacy Policy',
                            title: 'Nando’s privacy policy',
                            href: 'https://www.nandos.co.uk/privacy-policy',
                            type: 'Link'
                        },
                        {
                            text: 'Cookies Policy',
                            title: 'Nando’s cookie policy',
                            href: 'https://www.nandos.co.uk/cookies-policy',
                            type: 'Link'
                        },
                        {
                            text: 'Cookies Preferences',
                            title: 'Nando’s cookie preferences',
                            type: 'Link',
                            href: '#cookiespreferences',
                            action: 'open-cookies'
                        },
                        {
                            text: 'Slavery Statement',
                            href: 'https://www.nandos.co.uk/modern-slavery-statement',
                            type: 'Link'
                        },
                        {
                            text: 'Gender Pay Gap Report',
                            href: 'https://www.nandos.co.uk/genderpayreport',
                            type: 'Link'
                        },
                        {
                            text: 'Insurance Policy Details',
                            href: 'https://www.nandos.co.uk/insurance-policy-details',
                            type: 'Link'
                        },
                        {
                            text: 'NGHL Tax Strategy',
                            href: 'https://www.nandos.co.uk/nghl-tax-strategy-2021',
                            type: 'Link'
                        },
                        {
                            text: 'Stakeholder Engagement',
                            href: 'https://www.nandos.co.uk/stakeholder-engagement',
                            type: 'Link'
                        }
                    ]
                }
            ]
        }
    ]
};

export { footerData };
